import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class LayoutService {
  private readonly fullWidth = 250;
  private readonly iconOnlyWidth = 75;
  private sidebar = new BehaviorSubject<number>(0);
  sidebarWidth = this.sidebar.asObservable();

  constructor() {}

  public toggle() {
    if (this.sidebar.value === 0) {
      this.sidebar.next(this.iconOnlyWidth)
      return
    }
    
    if (this.sidebar.value === this.fullWidth) {
      this.sidebar.next(this.iconOnlyWidth)
      return
    }

    this.sidebar.next(this.fullWidth)
  }

  public isFull() {
    return this.sidebar.value === this.fullWidth
  }
}
